import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnChanges, OnDestroy,
  OnInit, Output, SimpleChanges, ViewEncapsulation
} from '@angular/core';

import { SwiperOptions } from 'swiper/types';
import { Subscription } from 'rxjs';

import { DeviceService, IMedia, SdBannerComponent, SizesEnum } from '@seb/web-design-system/core';
import { SdSliderComponent } from '@seb/web-design-system/sliders';

@Component({
  selector: 'sd-multimedia',
  templateUrl: './multimedia.component.html',
  styleUrls: ['./multimedia.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SdSliderComponent, SdBannerComponent]
})
export class SdMultimediaComponent implements OnInit, OnChanges, OnDestroy {
  constructor(
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef
  ) {}

  mobileSubscription: Subscription;
  isMobile$: boolean;
  isVideo: boolean;
  isSlider: boolean;
  sizesEnum = SizesEnum;

  @Input()
  context = 'Multimedia';

  @Input()
  medias: IMedia[];

  @Input()
  autoplay = false;

  @Input()
  loop = false;

  @Input()
  muted = true;

  @Input()
  noStyle = false;

  @Input()
  mediasConfig: SwiperOptions = {
    breakpoints: {
      0: {
        spaceBetween: 12
      },
      768: {
        spaceBetween: 12
      },
      1280: {
        spaceBetween: 20
      }
    }
  };

  @Input()
  twicPicsAutoSize = true;

  @Output()
  videoPlayed = new EventEmitter<{ status: string; title: string }>();

  @Output()
  videoEnded = new EventEmitter<{ status: string; title: string }>();

  @Input()
  class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.isSlider ? 'ds-component is-full-width is-slider' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  ngOnInit() {
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });

    this.isSlider = this.medias?.length > 1;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['medias']) {
      this.isSlider = this.medias?.length > 1;
    }
  }

  ngOnDestroy() {
    this.mobileSubscription?.unsubscribe();
  }

  onVideoPlayed() {
    this.videoPlayed.emit({ status: 'play', title: this.context });
  }

  onVideoEnded() {
    this.videoEnded.emit({ status: 'ended', title: this.context });
  }
}
